module.exports = __webpack_public_path__ + "img/code.88c828ab.svg";